import {FONT_METRICS} from './coverage'

export type CertificateFace = {
  family: string
  file: string
  metrics: {ascent: number; descent: number}
  scriptTest?: RegExp
}

function face(
  family: string,
  file: string,
  metricsKey: string,
  scriptTest?: RegExp
): CertificateFace {
  return {family, file, metrics: FONT_METRICS[metricsKey], scriptTest}
}

export const FACES = {
  pinyon: face(
    'AASA Pinyon Script',
    'certificates/fonts/PinyonScript-Regular.ttf',
    'PinyonScript-Regular'
  ),
  baskerville: face(
    'AASA Libre Baskerville',
    'certificates/fonts/LibreBaskerville-Regular.ttf',
    'LibreBaskerville-Regular'
  ),
  baskervilleBold: face(
    'AASA Libre Baskerville Bold',
    'certificates/fonts/LibreBaskerville-Bold.ttf',
    'LibreBaskerville-Bold'
  ),
  carlito: face(
    'AASA Carlito',
    'certificates/fonts/Carlito-Regular-latin.woff2',
    'Carlito-Regular'
  ),
  notoSerif: face(
    'AASA Noto Serif',
    'certificates/fonts/NotoSerif-Regular.ttf',
    'NotoSerif-Regular'
  ),
  notoSerifBold: face(
    'AASA Noto Serif Bold',
    'certificates/fonts/NotoSerif-Bold.ttf',
    'NotoSerif-Bold'
  ),
  naskh: face(
    'AASA Noto Naskh Arabic',
    'certificates/fonts/NotoNaskhArabic-Regular.ttf',
    'NotoNaskhArabic-Regular',
    /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/
  ),
  hebrew: face(
    'AASA Noto Serif Hebrew',
    'certificates/fonts/NotoSerifHebrew-Regular.ttf',
    'NotoSerifHebrew-Regular',
    /[֐-׿יִ-ﭏ]/
  ),
  devanagari: face(
    'AASA Noto Serif Devanagari',
    'certificates/fonts/NotoSerifDevanagari-Regular.ttf',
    'NotoSerifDevanagari-Regular',
    /[ऀ-ॿ꣠-ꣿ]/
  ),
  ethiopic: face(
    'AASA Noto Serif Ethiopic',
    'certificates/fonts/NotoSerifEthiopic-Regular.ttf',
    'NotoSerifEthiopic-Regular',
    /[ሀ-᎟ⶀ-⷟꬀-꬯]/
  ),
}

export const SCRIPT_FACES: CertificateFace[] = [
  FACES.naskh,
  FACES.hebrew,
  FACES.devanagari,
  FACES.ethiopic,
]

export function assetUrl(assetBaseUrl: string, file: string): string {
  return `${assetBaseUrl.replace(/\/+$/, '')}/${file}`
}

const loadedFaces = new Map<string, Promise<void>>()

export function loadFace(certificateFace: CertificateFace, assetBaseUrl: string): Promise<void> {
  const existing = loadedFaces.get(certificateFace.family)
  if (existing) {
    return existing
  }

  const loading = new FontFace(
    certificateFace.family,
    `url(${assetUrl(assetBaseUrl, certificateFace.file)})`
  )
    .load()
    .then((loaded) => {
      document.fonts.add(loaded)
    })
    .catch((error: unknown) => {
      loadedFaces.delete(certificateFace.family)
      throw error
    })
  loadedFaces.set(certificateFace.family, loading)
  return loading
}

export function fontString(stack: CertificateFace[], size: number): string {
  return `${size}px ${stack.map((item) => `"${item.family}"`).join(', ')}`
}
